import { getTextResult, textKey } from 'core/textResult'
const validateEmail = (email) => {
  return email.match(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
};


export const validateField = (values) => {
  let errors = {}
  if (!values.complaint_date) {
    errors.complaint_date = getTextResult(textKey.TEXTERROR1)
  }
  if (!values.complaints) {
    errors.complaints = getTextResult(textKey.TEXTERROR1)
  }
  if (!values.type_complaints) {
    errors.type_complaints = getTextResult(textKey.TEXTERROR1)
  }
  if (!values.project_or_location) {
    errors.project_or_location = getTextResult(textKey.TEXTERROR1)
  }
  if (!values.detail_complaint) {
    errors.detail_complaint = getTextResult(textKey.TEXTERROR1)
  }
  if (!values.sender_name) {
    errors.sender_name = getTextResult(textKey.TEXTERROR1)
  }
  if (!values.sender_last_name) {
    errors.sender_last_name = getTextResult(textKey.TEXTERROR1)
  }
  if (!values.sender_email) {
    errors.sender_email = getTextResult(textKey.TEXTERROR1)
  }
  if(values.sender_email){
    if(validateEmail(values.sender_email) == null){
    errors.sender_email = getTextResult(textKey.TEXTERROR2)
    }
  }
  if (!values.sender_mobile_no) {
    errors.sender_mobile_no = getTextResult(textKey.TEXTERROR1)
  } else if (!values.sender_mobile_no.startsWith('0')) {
    errors.sender_mobile_no = getTextResult(textKey.TEXTERROR3)
  } else if (values.sender_mobile_no.length < 9 || values.sender_mobile_no.length > 10) {
    errors.sender_mobile_no = getTextResult(textKey.TEXTERROR4)
  }
  return errors
}

